<template>
<v-card  flat  dark   style="border-radius:15px;margin:-15px" class="pa-0">

  <v-card-title >

  <v-list style="margin-left:-15px" v-if="item.params.check_post.pageType == 'page'" hide-details dense    >
  <v-list-tile >
  <v-list-tile-avatar  > <img :src="item.params.check_post.page.photo_50"> </v-list-tile-avatar>
  <v-list-tile-content><v-list-tile-title>
  {{item.params.check_post.page.first_name}} {{item.params.check_post.page.last_name}}
  </v-list-tile-title></v-list-tile-content>
  </v-list-tile>
  </v-list>

  <v-list style="margin-left:-15px" v-if="item.params.check_post.pageType == 'group'" hide-details dense  >
  <v-list-tile >
  <v-list-tile-avatar > <img :src="item.params.check_post.group.photo_50"> </v-list-tile-avatar>
  <v-list-tile-content><v-list-tile-title>
  {{item.params.check_post.group.name}}
  </v-list-tile-title></v-list-tile-content>
  </v-list-tile>
  </v-list>

  </v-card-title>

<v-card-text>

<div style="margin-top:-25px;">
<v-layout >
 
{{postText}}

</v-layout>


<v-layout v-if="link.url !== ''" style="margin-top:15px;">

<v-flex md4 v-if="link.photoUrl !==''">
<v-img :src="link.photoUrl"   max-height="70"  > </v-img>
</v-flex>
<v-flex md7 style="margin-left:10px">
<div>
<span style="font-size:1.2em">{{link.title}}</span> <br>
<span>{{link.url}}</span> <br>
<span>Прикреплена к посту</span>
</div>
</v-flex>



</v-layout>
</div>


</v-card-text>


</v-card>
</template>

<script>
import axios from 'axios'
export default {
props: ['item'],
data () {
return {
postText:"",
photos:{
  hi:[],
  low:[]
},
link:{
title:"",
url:"",
photoUrl:""
}

}
},
methods: {

sortAttachments(){
if(this.item.vk.attachments){
  this.item.vk.attachments.forEach(element => {
  if(element.type == 'link'){
    this.link.title = element.link.title
    this.link.url = element.link.url
    this.link.photoUrl = element.link.photo.sizes[0].url
  }
  if(element.type == 'photo'){
    if(element.photo.sizes[0].height < element.photo.sizes[0].width){
      let photo = element.photo.sizes[0]
      this.photos.low.push(photo)
    }
    if(element.photo.sizes[0].height > element.photo.sizes[0].width){
      let photo = element.photo.sizes[0]
      this.photos.hi.push(photo)
    }
  }
  })
}
},

tasksData(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
method: 'POST',
data: {
contentType: 'pages'
}
})
.then( response => {
this.tasks = response.data
})

},

},
computed:{
},
mounted(){

},
created(){
this.postText = this.item.vk.text
this.sortAttachments()
}

}
</script>

<style    >

</style>
